export enum UserRole {
  Admin = 1,
  ProductAdmin = 2,
  Seller = 3,
  Finance = 4,
  MarketingAdmin = 5,
}

export interface UserIdentity {
  id: string;
  fullName: string;
  role_id: UserRole;
  role: string;
  avatar: string;
}

export interface DashboardSummary {
  total_emails: number;
  opened_emails: number;
  total_whatsapp: number;
  delivered_whatsapp: number;
  total_visitors: number;
  registered_visitors: number;
  total_activities: number;
  active_activities: number;
}

export interface IInquiry {
  id: number;
  inquiry_date: string;
  inquiry_customer_id: number;
  inquiry_quantity: number;
  inquiry_price: number;
  accepted_inquiry_quantity: number;
  accepted_inquiry_price: number;
  inquiry_status_id: number;
  inquiry_product_id: number;
  inquiry_total: number;
  inquiry_city_name?: string;
  inquiry_order_id?: number;
  customer_contact?: string;
  product_name?: string;
  product_grade?: string;
  inquiry_status?: string;
  customer_contacted?: boolean;
  customer_approved?: boolean | null;
  customer_notes?: string | null;
}
